'use strict';

var veilleActu = veilleActu || {};
var $ = jQuery;

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
veilleActu.init = function () {
  veilleActu.move();

  // Fix behaviors.
  Drupal.behaviors.move = {
    attach: function (context, settings) {
      veilleActu.move();
    }
  };
};

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(veilleActu.init);

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
veilleActu.move = function () {

  // console.log('veilleActu');

  var blockVa = $('.block--veille-actu');

  blockVa.insertBefore('.view--general-search > .view__content');
  blockVa.addClass('visible').delay( 400 );

};
